export class UserVerify {
    public  userId : string;
    public  searchValue: string;
    public  skip : number;
    public  take : number;  
    public  companyCode : string;   
}

